module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openNotifsPanel($event)
      },
      "mouseenter": function($event) {
        _vm.isHoverNotifs = true
      },
      "mouseleave": _vm.delayClosePanel
    }
  }, [(_vm.nbNotif > 0) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.nbNotifString) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "ion-ios-bell-outline",
    class: {
      'shake': _vm.nbNotif > 0 && !_vm.showNotifs
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown",
    class: {
      shown: _vm.showNotifs
    },
    on: {
      "mouseenter": function($event) {
        _vm.isHoverNotifs = true
      },
      "mouseleave": _vm.delayClosePanel
    }
  }, [_c('li', {
    staticClass: "cc-clearfix"
  }, [_c('a', {
    staticClass: "cc-red",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeNotifsPanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "ion-close-round"
  })]), _vm._v(" "), _c('p', [_vm._v("\n                Notifications\n                "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.nbNotif))])])]), _vm._v(" "), _vm._l((_vm.loggedUser.notifications), function(notif, index) {
    return (index < _vm.maxNotifShown) ? _c('li', [_c('h4', {
      staticClass: "cc-clearfix"
    }, [_c('span', {
      staticClass: "notif-date"
    }, [_c('i', {
      staticClass: "ion-ios-clock-outline"
    }), _vm._v(" " + _vm._s(_vm._f("fromnow")(notif.date, 'fr')) + "\n                ")]), _vm._v("\n\n                " + _vm._s(_vm._f("capitalize")(notif.user)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "notif-detail cc-clearfix"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteNotif(index)
        }
      }
    }, [_c('i', {
      staticClass: "ion-close-round"
    })]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm._f("capitalize")(notif.action)) + "\n                ")])])]) : _vm._e()
  }), _vm._v(" "), (_vm.loggedUser.notifications.length > _vm.maxNotifShown) ? _c('li', {
    staticClass: "show-more"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.maxNotifShown += 2
      }
    }
  }, [_vm._v("\n                ...\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.nbNotif > 0) ? _c('li', {
    staticClass: "cc-txt-center"
  }, [_c('a', {
    staticClass: "btn cc-thin cc-bg-red delete-all",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteAll($event)
      }
    }
  }, [_vm._v("\n                Delete all\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.nbNotif < 1) ? _c('li', [_vm._m(0)]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notif-detail cc-clearfix"
  }, [_c('p', [_vm._v("\n                    No notification !\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-271c1274!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/notifications.vue
// module id = 216
// module chunks = 0